import React from 'react';
import { Link } from 'react-router-dom';
import "../../styles/logo.css";

function Logoyredes() {
  return (
    <div className='container-l'>
      <Link className='cont-link' to="/">
        <div className='logo-container element-left'>
        </div>
      </Link>
      <div className='element-right'>
        <Link className='cont-link' to="/">
          <span className='logo-text'>__Tributos__y__finanzas__</span>
        </Link>
      </div>
    </div>
  );
}

export default Logoyredes;